module.exports = __webpack_public_path__ + "img/koala-logo-grey.2f78b2ba.png";